<template>
  <div class="general">
    <container>
      <template v-slot:header>
        {{$ml.get(`Nutrients`)}}
      </template>
      <div class="content nutrients">
        <div 
          class="nutrient" 
          v-for="(nutrient, i) in nutrientTypes" 
          :ref="'nutrient-'+i" 
          v-if="!!extractionMethods.find(x => x.type == nutrient.key)"
        >
          <dropList>
            <template v-slot:header>
              {{nutrient.label}}
            </template>
            <template>
              <div class="methods">
                <div class="a-row titles">
                  <div class="sat-method">{{$ml.get(`Saturated Method`)}}</div>
                  <div class="unit">{{$ml.get(`Unit`)}}</div>
                  <div class="low">{{$ml.get(`Low`)}}</div>
                  <div class="adequate">{{$ml.get(`Adequate`)}}</div>
                  <div class="high">{{$ml.get(`High`)}}</div>
                </div>
                <div class="method" v-for="(method, i) in extractionMethods">
                  <template v-if="method.type == nutrient.key">
                    <div class="a-row">
                      <div class="sat-method">{{ method.name }}</div>
                      <div class="unit">{{ method.unit }}</div>
                      <div class="low">0 - {{toUnitC( method.type, method.unit, method.lowNum)}}</div>
                      <div class="adequate">{{toUnitC(method.type, method.unit, method.lowNum) }} - {{ toUnitC(method.type, method.unit,method.adequateNum) }}</div>
                      <div class="high">{{ toUnitC(method.type, method.unit, method.adequateNum) }} - {{ toUnitC(method.type, method.unit,method.highNum) }}</div>
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </dropList>
        </div>
      </div>
    </container>
  </div>
</template>

<script>

import Container from "@/components/common/HeadedContainer";
import DropList from "@/components/common/DropList";
import {UnitConverter} from '@/mixins/unit-converter.mixin';
export default {
  props: {
    nutrientTypes: Object,
    extractionMethods: Object,
  },
  components: {
    Container,
    DropList
  },
  methods:{
    toUnitC(type,unit,val){
      return val ? this.toUnit(type,unit, val).toFixedGentle(2) : 0
    },
  },
  mixins: [UnitConverter],
}
</script>

<style lang="scss" scoped>
  .general {
    width: 100%;
    margin-bottom: 8px;

    .content {
      width: 100%;
      padding: 16px;
      // background-color: #fff;
      flex-grow: 1;

      &.nutrients {
        .nutrient {
          
          .methods {
            height: auto;
            width: 100%;
            overflow: hidden;
            .a-row {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              padding: 16px;
              border-bottom: 1px solid #E4E5E6;
              .sat-method {
                flex-basis: 35%;
              }
              .low, .adequate, .high,.unit{
                flex-basis: 20%;
              }
              &.titles {
                > div {
                  text-transform: uppercase;
                  font-size: 12px;
                  font-weight: 600;
                  color: #4C5056;
                  &.low {
                    color: #5EC19B;
                  }
                  &.adequate {
                    color: #A7B975;
                  }
                  &.high {
                    color: #F2B14E;
                  }
                }
              }
            }
          }
        }

      }
    }
  }
</style>